import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledContainer = styled(Box, {
  alignItems: 'strech',
  backgroundColor: '$white',
  display: 'flex',
  flexDirection: 'column',
  gap: '$6',
  marginLeft: '$studyInsights$sidebarWidthClose',
  overflowX: 'clip',
});

export const HeaderStyled = styled(Box, {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: 'auto',
  maxWidth: '$studyInsights$maxWidth',
  padding: '$10 $6 $4 $6',
  variants: {
    withTooltip: {
      true: {
        padding: '$10 $6 0 $6',
      },
    },
  },
});

export const StyledPageLargeTitle = styled(Box, {
  color: '$darkBlue100',
  display: 'flex',
  fontSize: '$3xl',
  fontWeight: '$bold',
});

export const StyledPageLargeHeader = styled(Box, {
  backgroundColor: '$white',
  overflow: 'hidden',
  position: 'sticky',
  scrollBehavior: 'smooth',
  top: 0,
  transition: '1s ease-in-out',
  zIndex: '$stickyHeader',
  width: '100%',
});
